module.exports = __webpack_public_path__ + "img/skills2.2e5750f0.png";